import React from 'react';
import styles from './CardPageFeatures.module.css';
import { FlatCardData, BusinessCardData } from '../../CardsComponents/types';
import cn from 'classnames';

interface CardPageFeaturesProps {
  data: FlatCardData | BusinessCardData;
  type: 'flat' | 'business';
}

type FeatureOption = string | { id?: number; name?: string; image?: string | null };

interface FeatureCardProps {
  option: FeatureOption;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ option }) => {
  const [isImageFailed, setIsImageFailed] = React.useState(false);
  const optionName = typeof option === 'string' ? option : option?.name ?? '';
  const optionImage = typeof option === 'string' ? '' : (option?.image ?? '');
  const normalizedImage = typeof optionImage === 'string' ? optionImage.trim() : '';
  const hasImage = Boolean(normalizedImage) && !isImageFailed;

  return (
    <div className={cn(styles.feature_card, { [styles.feature_card_with_image]: hasImage, [styles.feature_card_no_image]: !hasImage })}>
      {hasImage && (
        <img
          src={normalizedImage}
          alt={optionName || 'Опция квартиры'}
          className={styles.feature_card_image}
          loading="lazy"
          onError={() => setIsImageFailed(true)}
        />
      )}
      <h3 className={styles.feature_card_title}>{optionName || 'Опция'}</h3>
    </div>
  );
};

const CardPageFeatures: React.FC<CardPageFeaturesProps> = ({ data, type }) => {
  const sourceOptions: FeatureOption[] =
    data.specialOptions && data.specialOptions.length > 0
      ? data.specialOptions
      : (data.windowOptions || []);

  if (!sourceOptions || sourceOptions.length === 0) {
    return null;
  }

  return (
    <div className={styles.features}>
      <div className={styles.block_title}>
        <h3>{type === 'flat' ? 'В этой квартире' : 'В этом помещении'}</h3>
      </div>
      <div className={styles.apartment_features_grid}>
        {sourceOptions.map((option, index) => (
          <FeatureCard
            key={`${typeof option === 'string' ? option : option.id ?? index}-${index}`}
            option={option}
          />
        ))}
      </div>
    </div>
  );
};

export default CardPageFeatures
